export const DeleteIcon = (props) => (
  <svg
    className='DeleteIcon'
    style={{ ...props?.style }}
    width='12'
    height='12'
    viewBox='0 0 12 12'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    onClick={props?.onClick}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M6 12C9.31371 12 12 9.31371 12 6C12 2.68629 9.31371 0 6 0C2.68629 0 0 2.68629 0 6C0 9.31371 2.68629 12 6 12ZM4.53033 3.46967C4.23744 3.17678 3.76256 3.17678 3.46967 3.46967C3.17678 3.76256 3.17678 4.23744 3.46967 4.53033L4.93934 6L3.46967 7.46967C3.17678 7.76256 3.17678 8.23744 3.46967 8.53033C3.76257 8.82322 4.23744 8.82322 4.53033 8.53033L6 7.06066L7.46967 8.53033C7.76256 8.82322 8.23743 8.82322 8.53033 8.53033C8.82322 8.23744 8.82322 7.76256 8.53033 7.46967L7.06066 6L8.53033 4.53033C8.82322 4.23744 8.82322 3.76256 8.53033 3.46967C8.23744 3.17678 7.76256 3.17678 7.46967 3.46967L6 4.93934L4.53033 3.46967Z'
      fill='inherit'
    />
  </svg>
);

export const DeleteIconNew = (props) => (
  <svg
    style={{ ...props?.style }}
    width='16'
    height='16'
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M8 2C11.3137 2 14 4.68629 14 8C14 11.3137 11.3137 14 8 14C4.68629 14 2 11.3137 2 8C2 4.68629 4.68629 2 8 2ZM10.5303 5.46973C10.2374 5.17683 9.76262 5.17683 9.46973 5.46973L8 6.93945L6.53027 5.46973C6.23738 5.17683 5.76262 5.17683 5.46973 5.46973C5.17683 5.76262 5.17683 6.23738 5.46973 6.53027L6.93945 8L5.46973 9.46973C5.17684 9.76262 5.17684 10.2374 5.46973 10.5303C5.76262 10.8232 6.23738 10.8232 6.53027 10.5303L8 9.06055L9.46973 10.5303C9.76262 10.8232 10.2374 10.8232 10.5303 10.5303C10.8232 10.2374 10.8232 9.76262 10.5303 9.46973L9.06055 8L10.5303 6.53027C10.8232 6.23738 10.8232 5.76262 10.5303 5.46973Z'
      fill='inherit'
    />
  </svg>
);
